export default __webpack_public_path__ + "static/media/worldmap.7a43af58.jpeg";